import React from 'react';

import { MenuItem } from '@mui/material';

import { useQueryState } from 'hooks/useQueryState';

import { useClusterRCFAnalysisStore } from 'store/clusterRCFAnalysis.store';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Dashboards/ExcellenceApps/ClusterRCFAnalysis/CompareTo/CompareTo.module.scss';
import Button from 'components/DesignSystem/Button/Button';
import { CustomizedDropdownMenu } from 'components/common';

export type CompareOptions = 'ITSELF' | 'PROJECT' | 'PORTFOLIO';

export const compareOptions: ISelectOption<CompareOptions>[] = [
    {
        label: 'Single Version',
        value: 'ITSELF',
    },
    {
        label: 'Project',
        value: 'PROJECT',
    },
    {
        label: 'Portfolio',
        value: 'PORTFOLIO',
    },
];

export const CompareTo = () => {
    const [compare, setCompare] = useQueryState<CompareOptions>('clusterScope', 'ITSELF');
    const { update } = useClusterRCFAnalysisStore();

    const handleCompare = (item: CompareOptions) => {
        setCompare(item);
        update({ selectedClusterId: null });
    };

    return (
        <div className={classes.compareContainer}>
            <CustomizedDropdownMenu
                triggerElement={
                    <Button variant={'secondary'} endIcon={<MuiIcon icon={'keyboard_arrow_down'} color={'inherit'} />}>
                        Cluster Scope:{compare ? compareOptions.find((item) => item.value === compare)?.label : ''}
                    </Button>
                }
            >
                {compareOptions.map((item) => {
                    return (
                        <MenuItem
                            key={item.value}
                            className={classes.compareOption}
                            onClick={() => handleCompare(item.value)}
                            selected={item.value === compare}
                        >
                            {item.label}
                        </MenuItem>
                    );
                })}
            </CustomizedDropdownMenu>
        </div>
    );
};
